import { PaymentChargeType } from "common/records/Payment";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { Nullable } from "common/types";
import { Map, Record } from "immutable";

export const FETCH_CHECKOUT_TOKEN = "@integrations/paysimple/FETCH_CHECKOUT_TOKEN";
export const RECEIVE_CHECKOUT_TOKEN = "@integrations/paysimple/RECEIVE_CHECKOUT_TOKEN";
export const RECEIVE_CHECKOUT_TOKEN_ERROR = "@integrations/paysimple/RECEIVE_CHECKOUT_TOKEN_ERROR";
export const FETCH_AUTHORIZATION = "@integrations/paysimple/FETCH_AUTHORIZATION";
export const SET_AUTHORIZATION = "@integrations/paysimple/SET_AUTHORIZATION";

export interface PaySimpleCheckoutToken {
  JwtToken?: string;
  Expiration?: string;
  error?: string;
}

export class PaySimpleTokenRecord extends Record<{
  token: Map<keyof PaySimpleCheckoutToken, string>;
  error: Nullable<string>;
  loading: boolean;
}>({
  token: Map<keyof PaySimpleCheckoutToken, string>(),
  error: null,
  loading: false,
}) {}

export interface PaySimpleToken {
  username: string;
  api_key: string;
  hpp_url?: string;
  loading?: boolean;
}

export interface IMakePaymentData {
  first_name: string;
  last_name: string;
  description: string;
  zipCode?: string;
  charge_type?: PaymentChargeType;
  postal?: string;
  amount: number;
  email: string;
  user_id: number;
  job_id: number;
  estimate_id?: number;
}

export const PaySimpleActions = {
  fetchCheckoutToken: (orgId: number) => createAction(FETCH_CHECKOUT_TOKEN, { orgId }),
  receiveCheckoutToken: (orgId: number, token: PaySimpleCheckoutToken) =>
    createAction(RECEIVE_CHECKOUT_TOKEN, { orgId, token }),
  receiveCheckoutTokenError: (orgId: number, error: string) =>
    createAction(RECEIVE_CHECKOUT_TOKEN_ERROR, { orgId, error }),
  fetchAuthorization: (orgId: number) => createAction(FETCH_AUTHORIZATION, orgId),
  setAuthorization: (orgId: number, authorization: PaySimpleToken) =>
    createAction(SET_AUTHORIZATION, { orgId: orgId, authorization: authorization }),
};

export type PaySimpleActions = ActionsUnion<typeof PaySimpleActions>;
